import type { RuleDefinition, RuleFinding } from '../domain/types';
import { getCellText } from '../domain/cells';
import { normalizeCode } from '../utils/text';
import { finding, groupRows, normalizedCoreSignature } from './helpers';

export const BQ009: RuleDefinition = {
  id: 'BQ009',
  name: '同编码核心信息冲突',
  description: '仅在同一工作表内比较相同项目编码的名称、单位和项目特征。',
  defaultSeverity: 'error',
  enabled: true,
  applicableFields: ['code', 'name', 'unit', 'description'],
  message: '同一工作表内相同项目编码存在不同的核心信息。',
  suggestion: '请对照关联行核对项目名称、计量单位和项目特征，确认编码是否复用。',
  check: ({ detailRows }) => {
    const results: RuleFinding[] = [];
    const groups = groupRows(detailRows, (row) => normalizeCode(getCellText(row, 'code')));
    groups.forEach((rows) => {
      const firstBySignature = new Map<string, number>();
      [...rows]
        .sort((left, right) => left.excelRow - right.excelRow)
        .forEach((row) => {
          const signature = normalizedCoreSignature(row);
          if (firstBySignature.has(signature)) return;
          const relatedRows = [...firstBySignature.values()];
          firstBySignature.set(signature, row.excelRow);
          if (relatedRows.length === 0) return;
          results.push(
            finding(row, 'code', {
              currentValue: getCellText(row, 'code'),
              relatedRows,
              message: `项目编码与第 ${relatedRows.join('、')} 行相同，但名称、单位或项目特征存在冲突。`,
            }),
          );
        });
    });
    return results;
  },
};
